import Axios from 'axios';
import axiosRetry from 'axios-retry';
import store from '../store';
import postQueue from '../services/postQueue';
import attendSaveQueue from '../services/attendSaveQueue';
import { tokenService } from './tokenService';

const BASE_URL =
  process.env.NODE_ENV === 'production' ? '/api/' : '//localhost:3030/api/';

var axios = Axios.create({
  withCredentials: true,
});
axios.defaults.baseURL = BASE_URL;

axiosRetry(axios, {
  retries: 2,
  retryDelay: axiosRetry.exponentialDelay,
  retryCondition: (error) => {
    return !error.response;
  },
});

export default {
  _401interceptor: null,
  get(endpoint, data) {
    return ajax(endpoint, 'GET', data);
  },
  post(endpoint, data) {
    return ajax(endpoint, 'POST', data);
  },
  put(endpoint, data) {
    return ajax(endpoint, 'PUT', data);
  },
  delete(endpoint, data) {
    return ajax(endpoint, 'DELETE', data);
  },
  setHeader() {
    axios.defaults.headers.common[
      'Authorization'
    ] = `Bearer ${tokenService.getToken()}`;
  },
  removeHeader() {
    axios.defaults.headers.common = {};
  },
  customRequest(method, endpoint, data, options) {
    return ajax(endpoint, method, data, options);
  },
  mount401Interceptor() {
    this._401interceptor = axios.interceptors.response.use(
      (response) => {
        return response;
      },
      async (error) => {
        if (error.request.status == 401) {
          if (error.config.url.includes('auth/token')) {
            // Refresh token has failed. Logout the user
            store.dispatch('auth/logout');
            throw error;
          } else {
            // Refresh the access token
            try {
              await store.dispatch('auth/refreshToken');
              return this.customRequest(
                error.config.method,
                error.config.url,
                error.config.data,
              );
              // Retry the original request
            } catch (e) {
              // Refresh has failed - reject the original request
              throw error;
            }
          }
        }
        // If error was not 401 just reject as is
        throw error;
      },
    );
  },
  unmount401Interceptor() {
    // Eject the interceptor
    axios.interceptors.response.eject(this._401interceptor);
  },
};

async function ajax(endpoint, method = 'get', data = null, options = {}) {
  try {
    const res = await axios({
      url: endpoint,
      method,
      data,
      ...options,
    });
    if (!store.getters['user/isOnline']) store.commit('user/setIsOnline', true);
    postQueue.playQueue();
    attendSaveQueue.playQueue();
    if (!res.data) return res;
    if (options.responseType) return res;
    return res && res.data;
  } catch (err) {
    if (!err.response) {
      store.commit({
        type: 'user/setAlertData',
        alertData: { txt: 'Error de red!', type: 'failure' },
      });
      store.commit('user/setIsOnline', false);
      throw Error('Error de red');
    } else {
      const errMsg = err.message
        ? JSON.stringify(err.message) + ' ' + err.response.data
        : JSON.stringify(err);
      const txt = 'Ocurrió un error en el systema: ' + errMsg;
      store.commit({
        type: 'user/setAlertData',
        alertData: { txt, type: 'failure' },
      });
    }
    throw err;
  }
}
